

import React, { useEffect, useState } from "react";
import { Container, Button, Table } from "react-bootstrap";
import axios from "axios";
import './Greetings.css'

const EventPhotos = () => {
  const [eventPhotos, setEventPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  const district = sessionStorage.getItem('userDistrict');

  useEffect(() => {
    const data = sessionStorage.getItem('userData');
    if (data) {
      setUserData(JSON.parse(data));
    }
  }, []);

  const fetchEventPhotos = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://lionsnewsapi.emedha.in/admin/api/event-photos?district=${district}`);
      setEventPhotos(response.data);
    } catch (error) {
      console.error("Error fetching event photos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEventPhotos();
  }, [district]);

  const handleApprove = async (id) => {
    try {
      await axios.post(`https://lionsnewsapi.emedha.in/admin/api/event-photos/approve/${id}`);
      setEventPhotos((prevPhotos) =>
        prevPhotos.map((photo) =>
          photo.id === id ? { ...photo, status: "approved" } : photo
        )
      );
    } catch (error) {
      console.error("Error approving event photo:", error);
    }
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = '/';
  };

  return (
    <div className="dashboard-layout">
      {/* Sidebar */}
      <div className="sidebar-nav">
        <h2>Menu</h2>
        <ul>
          <li>
            <button className="side-button" onClick={() => window.location.href = '/Dashboard'}>Posts</button>
          </li>
          <li>
            <button className="side-button" onClick={() => window.location.href = '/greetings'}>Greetings</button>
          </li>
          <li>
            <button className="side-button" onClick={() => window.location.href = '/profile'}>Verified Profile</button>
          </li>
          <li>
            <button className="side-button" onClick={handleLogout}>LogOut</button>
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="content-section">
        <h1 className="page-title">Event Photos - District {district}</h1>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Event Name</th>
                <th>Photo</th>
                <th>Description</th>
                <th>Status</th>
                <th>Uploaded At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {eventPhotos.map((photo) => (
                <tr key={photo.id}>
                  <td>{photo.id}</td>
                  <td>{photo.event_name}</td>
                  <td>
                    <img
                      src={photo.photo_path}
                      alt="event"
                      style={{ width: "100px", height: "auto" }}
                    />
                  </td>
                  <td>{photo.description}</td>
                  <td>{photo.status}</td>
                  <td>{new Date(photo.uploaded_at).toLocaleString()}</td>
                  <td>
                    {photo.status === "pending" ? (
                      <Button variant="success" size="sm" onClick={() => handleApprove(photo.id)}>
                        Approve
                      </Button>
                    ) : (
                      <span className="text-success">Approved</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default EventPhotos;
